import { IAppComponent } from "./IAppComponent";

export class FramePopup implements IAppComponent {

    public static instance: FramePopup;

    private container: HTMLElement;
    private activePopup: HTMLElement;
    private isModal: boolean;

    /**
     * Constructor
     */

    constructor() {
        this.activePopup = null;
        FramePopup.instance = this;
    }

    /**
     * Initialize popup container.
     */
    public initialize(): void {
        this.container = document.getElementById("framePopupContainer");

        // hide non modal popup on click outside of the popup
        document.addEventListener("click", (ev: MouseEvent) => {
            if (this.activePopup && !this.isModal) {
                let targetElement = ev.target as Node;
                while (targetElement) {
                    if (targetElement == this.activePopup) {
                        return;
                    }
                    targetElement = targetElement.parentNode;
                }
                this.hide(this.activePopup);
            }
        });
    }

    /**
     * Is popup window visible
     * @param popup
     */
    public isPopupVisible(popup: HTMLElement): boolean {
        return popup.classList.contains("show");
    }

    /**
     * Show or hide a popup
     * @param popup HTMLElement of the popup
     */

    public toggle(popup: HTMLElement) {
        if (this.isPopupVisible(popup)) {
            this.hide(popup);
        }
        else {
            this.show(popup);
        }
    }

    /**
     * Show a popup.
     * @param popup Popup element.
     */

    public show(popup: HTMLElement) {
        if (this.activePopup) {
            this.hide(this.activePopup);
        }

        this.isModal = popup.classList.contains("modal");
        if (this.isModal) {
            this.container.classList.add("modal-bg");
        }

        popup.classList.add("show");
        this.activePopup = popup;
    }

    public showAbsolute(popup: HTMLElement, parentElement: HTMLElement) {
        const rectParent = parentElement.getBoundingClientRect();
        const left = rectParent.left;
        let top = rectParent.bottom + 1;

        popup.style.left = left + "px";
        popup.style.top = top + "px";
        popup.style.position = "absolute";
        popup.classList.add("show");
        popup.tabIndex = 0;
        popup.focus();

        const bottom = top + popup.offsetHeight;
        if (bottom > window.innerHeight) {
            top = window.innerHeight - popup.offsetHeight;
            popup.style.top = top + "px";
        }
    }

    /**
     * Hide a popup.
     * @param popup Popup element.
     */
    public hide(popup: HTMLElement) {
        popup.classList.remove("show");
        popup.classList.remove("show-flex");
        this.container.classList.remove("modal-bg");
        this.activePopup = null;
    }
}
